<template>
    <video class="fullScreenVideoBackground" autoplay muted loop>
      <source :src="`${baseUrl}${videoSrc}`" type="video/mp4">
      Your browser does not support the video tag.
    </video>
</template>

<script>
export default {
    props: ['videoSrc'],
    data: function() {
        return {
            baseUrl: process.env.BASE_URL
        }
    }
}
</script>

<style lang="scss" scoped>

    .fullScreenVideoBackground {
        position: absolute;
        top: 50%;
        left: 50%;
        bottom: 0;
        right: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        transform: translate3d(-50%, -50%, 0);
    }

    @media (min-aspect-ratio: 16/9) {
        .fullScreenVideoBackground {
            width: 100%;
            height: auto;
        }
    }

    @media (max-aspect-ratio: 16/9) {
        .fullScreenVideoBackground {
            width: auto;
            height: 100%;
        }
    }

</style>
